(() => {
  if (customElements.get('aguila-bogo-banner')) return;
  class AguilaBogoBanner extends HTMLElement {
    connectedCallback() {
      this.storageKey = `aguila-bogo-dismissed:${this.dataset.campaign}`;
      this.revision = 0;
      this.closed = false;
      try { this.closed = sessionStorage.getItem(this.storageKey) === '1'; } catch {}
      if (window.Shopify?.designMode) this.closed = false;
      this.hidden = this.closed || this.dataset.offerApplied === 'true';
      this.closeButton = this.querySelector('.aguila-bogo-close');
      this.closeButton.hidden = false;
      this.closeHandler = () => {
        this.closed = true;
        this.hidden = true;
        try { sessionStorage.setItem(this.storageKey, '1'); } catch {}
      };
      this.closeButton.addEventListener('click', this.closeHandler);
      this.schedule = () => {
        this.revision += 1;
        this.controller?.abort();
        clearTimeout(this.timer);
        if (!this.closed) this.timer = setTimeout(() => this.refresh(), 180);
      };
      this.events = ['cart:updated', 'cart:refresh', 'cart:change'];
      this.events.forEach(name => document.addEventListener(name, this.schedule));
      window.addEventListener('pageshow', this.schedule);
      window.addEventListener('focus', this.schedule);
      if ('PerformanceObserver' in window) {
        try {
          this.observer = new PerformanceObserver(list => {
            if (list.getEntries().some(entry => {
              const url = new URL(entry.name, location.origin);
              return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
            })) this.schedule();
          });
          this.observer.observe({ type: 'resource', buffered: true });
        } catch {}
      }
    }
    async refresh() {
      const revision = this.revision;
      this.controller = new AbortController();
      try {
        const url = new URL(location.href);
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Banner refresh failed');
        const html = await response.text();
        if (revision !== this.revision || !this.isConnected) return;
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('aguila-bogo-banner');
        if (!next) throw new Error('Banner unavailable');
        const message = this.querySelector('.aguila-bogo-message');
        const nextMessage = next.querySelector('.aguila-bogo-message');
        if (message.innerHTML !== nextMessage.innerHTML) message.innerHTML = nextMessage.innerHTML;
        this.dataset.quantity = next.dataset.quantity;
        this.dataset.offerApplied = next.dataset.offerApplied;
        this.hidden = this.closed || this.dataset.offerApplied === 'true';
      } catch {
        if (revision === this.revision) this.hidden = true;
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.events?.forEach(name => document.removeEventListener(name, this.schedule));
      window.removeEventListener('pageshow', this.schedule);
      window.removeEventListener('focus', this.schedule);
      this.closeButton?.removeEventListener('click', this.closeHandler);
    }
  }
  customElements.define('aguila-bogo-banner', AguilaBogoBanner);
})();
